<div class="origin" cdkOverlayOrigin #origin="cdkOverlayOrigin"></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="16"
  [cdkConnectedOverlayPositions]="positions"
  cdkConnectedOverlayPanelClass="motn-datetime-picker-pane"
>
  <div class="datetime-picker-card" (motnClickOutsideService)="closed$.emit()" (motnEscapeKey)="closed$.emit()">

    <mat-calendar
      [selected]="selectedDate"
      [maxDate]="maxDate"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>

    <div class="time-section">
      <span class="time-label">TIME</span>

      <motn-time-picker
        [hour]="hour"
        [minute]="minute"
        [second]="second"
        [period]="period"
        [showSeconds]="true"
        (hourChange)="onHourChange($event)"
        (minuteChange)="onMinuteChange($event)"
        (secondChange)="onSecondChange($event)"
        (periodChange)="onPeriodChange($event)"
      ></motn-time-picker>
    </div>

  </div>
</ng-template>
